/**
 * Helpers for flair text editing (emoji vs text).
 */

export function extractEmojisFromFlairText(flairText: string): string {
  if (!flairText) return '';
  const emojiMatch = flairText.match(/^(:[^:]+:\s*)+/);
  if (!emojiMatch) return '';
  const emojis = emojiMatch[0].match(/:[^:]+:/g) || [];
  return emojis.join(' ');
}

export function extractTextWithoutEmojis(flairText: string): string {
  if (!flairText) return '';
  return flairText.replace(/^(:[^:]+:\s*)+/, '').trim();
}
